import { withTranslation } from '@application/i18n/with_translation';
import { LiveAnnouncerController } from '@component/live_announcer/live_announcer.controller';
import { useService } from '@visiba/instantiation';
import { useLayoutEffect } from 'react';

export function useTitle(title: string): void {
	const liveAnnouncerController = useService(LiveAnnouncerController);

	useLayoutEffect(
		function whenHookMounts() {
			const prevTitle = document.title;
			document.title = title;

			const removeMessage = liveAnnouncerController.announce(
				withTranslation('Common.Word.A11y.NavigateTo', {
					location: title,
				}),
			);

			return () => {
				removeMessage();
				document.title = prevTitle;
			};
		},
		[liveAnnouncerController, title],
	);
}
